/** localStorage wrapped in try/catch: private windows and blocked storage must not break the app. */
export function readPref(key: string): string | null {
  try {
    return window.localStorage.getItem(`deizi:${key}`);
  } catch {
    return null;
  }
}

export function writePref(key: string, value: string): void {
  try {
    window.localStorage.setItem(`deizi:${key}`, value);
  } catch {
    // Preference just won't persist.
  }
}
